"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDomainObjectTypeLabel = exports.getAssociationDisplayName = exports.mapObjectRefsToDodIndices = exports.convertQueryToObjectRef = exports.getDodEntities = void 0;
var truncate_1 = require("./truncate");
function getDodEntities(dodApi, objectRefs, logger) {
    return __awaiter(this, void 0, void 0, function () {
        var indices, _a, error_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 4, , 5]);
                    indices = __spreadArray([], mapObjectRefsToDodIndices(objectRefs !== null && objectRefs !== void 0 ? objectRefs : {}), true);
                    if (!(indices.length > 0)) return [3 /*break*/, 2];
                    return [4 /*yield*/, dodApi.entities.get(indices)];
                case 1:
                    _a = _b.sent();
                    return [3 /*break*/, 3];
                case 2:
                    _a = [];
                    _b.label = 3;
                case 3: return [2 /*return*/, _a];
                case 4:
                    error_1 = _b.sent();
                    logger.error(error_1);
                    return [2 /*return*/, []];
                case 5: return [2 /*return*/];
            }
        });
    });
}
exports.getDodEntities = getDodEntities;
function convertQueryToObjectRef(query) {
    return Object.entries(query).reduce(function (objectRef, _a) {
        var _b;
        var type = _a[0], identifierOrIdentifiers = _a[1];
        return __assign(__assign({}, objectRef), (_b = {}, _b[type] = castArray(identifierOrIdentifiers), _b));
    }, {});
}
exports.convertQueryToObjectRef = convertQueryToObjectRef;
function castArray(input) {
    return Array.isArray(input) ? input : [input];
}
function mapObjectRefsToDodIndices(refs) {
    return Object.entries(refs).reduce(function (indices, _a) {
        var type = _a[0], identifiers = _a[1];
        return indices.concat((identifiers !== null && identifiers !== void 0 ? identifiers : []).map(function (id) { return ({ type: type, id: id }); }));
    }, []);
}
exports.mapObjectRefsToDodIndices = mapObjectRefsToDodIndices;
function getAssociationDisplayName(context, includeLabel, truncateLength) {
    var pieces = [];
    if (includeLabel) {
        pieces.push("[".concat(getDomainObjectTypeLabel(context), "]"));
    }
    pieces.push((0, truncate_1.truncateMiddle)(context.displayName || '', truncateLength || 25));
    return pieces.join(' ').trim();
}
exports.getAssociationDisplayName = getAssociationDisplayName;
function getDomainObjectTypeLabel(domainObject) {
    var lowered = domainObject.type.toLowerCase().replace('-', ' ');
    return lowered.charAt(0).toUpperCase() + lowered.slice(1);
}
exports.getDomainObjectTypeLabel = getDomainObjectTypeLabel;
